var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row margin-top-4x", staticStyle: { padding: "5px" } },
    [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "table", staticStyle: { width: "70%" } }, [
          _c(
            "thead",
            {
              directives: [
                {
                  name: "hasPermits",
                  rawName: "v-hasPermits:prevent",
                  value: ["channel_user"],
                  expression: "['channel_user']",
                  arg: "prevent"
                }
              ]
            },
            [
              _c("tr", [
                _c("th", [_vm._v("\n            Ancillary Name\n          ")]),
                _vm._v(" "),
                _c("th", [
                  _vm._v("\n            Ancillary Access\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    directives: [
                      {
                        name: "hasPermits",
                        rawName: "v-hasPermits:allow",
                        value: ["super_admin"],
                        expression: "['super_admin']",
                        arg: "allow"
                      }
                    ]
                  },
                  [_vm._v("\n            Production Access\n          ")]
                ),
                _vm._v(" "),
                _c("th", [_vm._v("\n            Markup Type\n          ")]),
                _vm._v(" "),
                _c("th", [_vm._v("\n            Markup Value\n          ")]),
                _vm._v(" "),
                _c("th", [_vm._v("\n            Reslab Fee Type\n          ")]),
                _vm._v(" "),
                _c("th", [_vm._v("\n            Reslab Fee\n          ")]),
                _vm._v(" "),
                _c("th", { staticStyle: { display: "flex" } }, [
                  _vm._v("\n            Additional Fields\n          ")
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.formData.ancillaries, function(ancillary, i) {
                return [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "hasPermits",
                          rawName: "v-hasPermits:prevent",
                          value: ["channel_user"],
                          expression: "['channel_user']",
                          arg: "prevent"
                        }
                      ]
                    },
                    [
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.getAncillaryName(ancillary)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: ancillary.access,
                              expression: "ancillary.access"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(ancillary.access)
                              ? _vm._i(ancillary.access, null) > -1
                              : ancillary.access
                          },
                          on: {
                            change: function($event) {
                              var $$a = ancillary.access,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      ancillary,
                                      "access",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      ancillary,
                                      "access",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(ancillary, "access", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors["ancillaries." + i + ".access"]
                          ? _c("div", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.errors[
                                      "ancillaries." + i + ".access"
                                    ][0]
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: ["super_admin"],
                              expression: "['super_admin']",
                              arg: "allow"
                            }
                          ]
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ancillary.production_access,
                                expression: "ancillary.production_access"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                ancillary.production_access
                              )
                                ? _vm._i(ancillary.production_access, null) > -1
                                : ancillary.production_access
                            },
                            on: {
                              change: function($event) {
                                var $$a = ancillary.production_access,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        ancillary,
                                        "production_access",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        ancillary,
                                        "production_access",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(ancillary, "production_access", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors["ancillaries." + i + ".production_access"]
                            ? _c("div", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.errors[
                                        "ancillaries." +
                                          i +
                                          ".production_access"
                                      ][0]
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass: "input-group radio",
                            staticStyle: { "margin-top": "0" }
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: ancillary.markup_type,
                                    expression: "ancillary.markup_type"
                                  }
                                ],
                                attrs: { type: "radio", value: "percentage" },
                                domProps: {
                                  checked: _vm._q(
                                    ancillary.markup_type,
                                    "percentage"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      ancillary,
                                      "markup_type",
                                      "percentage"
                                    )
                                  }
                                }
                              }),
                              _vm._v("\n                  %\n                ")
                            ]),
                            _vm._v("\n                 \n                "),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: ancillary.markup_type,
                                    expression: "ancillary.markup_type"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  value: "fixed",
                                  disabled:
                                    ancillary.ancillary_type === "lounge"
                                },
                                domProps: {
                                  checked: _vm._q(
                                    ancillary.markup_type,
                                    "fixed"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      ancillary,
                                      "markup_type",
                                      "fixed"
                                    )
                                  }
                                }
                              }),
                              _vm._v("\n                  $\n                ")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("editable-text", {
                            attrs: { value: ancillary.markup_value },
                            on: {
                              valueSaved: function($event) {
                                return _vm.markupValueChanged($event, i)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors["ancillaries." + i + ".markup_value"]
                            ? _c("div", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.errors[
                                        "ancillaries." + i + ".markup_value"
                                      ][0]
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass: "input-group radio",
                            staticStyle: { "margin-top": "0" }
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: ancillary.reslab_fee_type,
                                    expression: "ancillary.reslab_fee_type"
                                  }
                                ],
                                attrs: { type: "radio", value: "percentage" },
                                domProps: {
                                  checked: _vm._q(
                                    ancillary.reslab_fee_type,
                                    "percentage"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      ancillary,
                                      "reslab_fee_type",
                                      "percentage"
                                    )
                                  }
                                }
                              }),
                              _vm._v("\n                  %\n                ")
                            ]),
                            _vm._v("\n                 \n                "),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: ancillary.reslab_fee_type,
                                    expression: "ancillary.reslab_fee_type"
                                  }
                                ],
                                attrs: { type: "radio", value: "fixed" },
                                domProps: {
                                  checked: _vm._q(
                                    ancillary.reslab_fee_type,
                                    "fixed"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      ancillary,
                                      "reslab_fee_type",
                                      "fixed"
                                    )
                                  }
                                }
                              }),
                              _vm._v("\n                  $\n                ")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("editable-text", {
                            attrs: { value: ancillary.reslab_fee_value },
                            on: {
                              valueSaved: function($event) {
                                return _vm.reslabFeeValueChanged($event, i)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors["ancillaries." + i + ".reslab_fee_value"]
                            ? _c("div", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.errors[
                                        "ancillaries." + i + ".reslab_fee_value"
                                      ][0]
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "max-width": "200px" } }, [
                        ancillary.additional_fields &&
                        Object.keys(ancillary.additional_fields).length > 0
                          ? _c(
                              "table",
                              {
                                staticClass: "table table-sm",
                                staticStyle: {
                                  "background-color": "inherit",
                                  width: "100%",
                                  "max-width": "100%"
                                }
                              },
                              [
                                _c(
                                  "tbody",
                                  _vm._l(ancillary.additional_fields, function(
                                    field,
                                    key
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        key: key,
                                        staticStyle: { "white-space": "nowrap" }
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              padding: "0",
                                              "padding-right": "15px",
                                              "white-space": "nowrap"
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.formatKey(key)))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "padding-top": "0",
                                              "word-break": "break-word"
                                            }
                                          },
                                          [
                                            _c("editable-text", {
                                              attrs: { value: field.value },
                                              on: {
                                                valueSaved: function($event) {
                                                  return _vm.additionalFieldChanged(
                                                    $event,
                                                    key,
                                                    i
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ancillary.ancillary_type === "lounge" &&
                        _vm.isSuperAdmin
                          ? _c(
                              "div",
                              { staticStyle: { "font-size": "11px" } },
                              [
                                _vm._v(
                                  "\n                Please note the markup cannot be applied as per the providers request. Instead we collect an 8% commission from the retail price\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.hasAncillaries
        ? _c(
            "div",
            { staticStyle: { padding: "5px" } },
            [
              _c(
                "tabs",
                {
                  attrs: { justified: true },
                  on: { tabChange: _vm.handleTabChange }
                },
                _vm._l(_vm.accessibleAncillaries, function(ancillary) {
                  return _c(
                    "tab",
                    {
                      key: ancillary.ancillary_type,
                      attrs: { title: _vm.getAncillaryName(ancillary) }
                    },
                    [
                      _c(_vm.getComponentName(ancillary.ancillary_type), {
                        tag: "component",
                        attrs: {
                          formData: _vm.formData,
                          activeTab: _vm.localActiveTab,
                          ancillary: ancillary,
                          ancillaryIndex: _vm.getAncillaryIndex(ancillary),
                          testingMode: _vm.testingMode
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b9ce30b", { render: render, staticRenderFns: staticRenderFns })
  }
}